import {
  blupayApi,
  getApiError,
} from "../api/client";

export const executionService = {
  executeLeg: async (
    legId
  ) => {
    try {
      const res =
        await blupayApi.post(
          `/provider-execution/legs/${legId}/execute`
        );

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  markCompleted: async (
    legId
  ) => {
    try {
      const res =
        await blupayApi.post(
          `/provider-execution/legs/${legId}/completed`
        );

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  markFailed: async (
    legId,
    payload
  ) => {
    try {
      const res =
        await blupayApi.post(
          `/provider-execution/legs/${legId}/failed`,
          payload
        );

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },
};